// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {EventitemScreenLayout} from 'app_components/screens/landing/eventitem'
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @import services
import PostService from 'app_services/campus/postService'
// @end

// @ADD Component types
interface IEventitemScreenProps {
  eventData: any
  match?: any
}
interface IEventitemScreenState {
  post: IPost | null
  loading_post: boolean
}

class EventitemScreen extends Component<IEventitemScreenProps, IEventitemScreenState> {

  private postService: PostService;

  constructor(props: IEventitemScreenProps){
    super(props)
    this.state = {
      post: null,
      loading_post: true,
    }
    this.postService = new PostService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props?.match?.params?.slug) {
      await this.getPost(this.props?.match?.params?.slug)
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = async (before: any, after: any) => {
    if (this.props?.match?.params?.slug !== before?.match?.params.slug) {
      await this.getPost(this.props?.match?.params?.slug)
    }
  }

  // @Add custom methods

  getPost = async (slug: string) => {
    this.setState({ loading_post: true })

    let post: any = null

    const newsResponse = await this.postService.fetchPost(slug)

    if (newsResponse && newsResponse.post) {
      post = newsResponse.post
    }

    this.setState({
      post,
      loading_post: false
    })
  }

  render() {
    return(
      <EventitemScreenLayout
        post={this.state.post}
        loading_post={this.state.loading_post}
      />
    )
  }
}

export default EventitemScreen
